var TYPE = "QUICK_MESSAGE_ACTION";
export var isQuickMessageActionMessage = function isQuickMessageActionMessage(m) {
  return (m === null || m === void 0 ? void 0 : m.type) === TYPE;
};
export var quickMessageActionMessage = function quickMessageActionMessage(_ref) {
  var action = _ref.action;
  return {
    type: TYPE,
    payload: {
      action: action
    }
  };
};